import * as actionTypes from '../action-types';
import { WatchersActions } from '../actions';

const defaultState: Array<string> = [];

export function watchersKeysReducer(
  state = defaultState,
  action: WatchersActions,
) {
  switch (action.type) {
    case actionTypes.SET_WATCHERS: {
      const { watchers } = action.payload;
      return watchers.map(watcher => watcher.key);
    }
    case actionTypes.CREATE_WATCHER: {
      const { watcher } = action.payload;
      return [...state, watcher.key];
    }
    case actionTypes.DELETE_WATCHER: {
      const { watcherKey } = action.payload;
      return state.filter((key: string) => key !== watcherKey);
    }
    case actionTypes.SET_WATCHER: {
      const { watcher } = action.payload;
      return state.includes(watcher.key) ? state : [...state, watcher.key];
    }
    default: {
      return state;
    }
  }
}
